export function Tealium(getProfile) {
    const getVisitorId = () => { var _a; return (_a = getProfile()) === null || _a === void 0 ? void 0 : _a.tealium_visitor_id; };
    const getTealiumProperties = (prefix, mapper) => {
        const profile = getProfile();
        let props = '';
        for (const key in profile) {
            if (key.startsWith(prefix)) {
                props += mapper(profile[key], key.replace(prefix, '')) + '|';
            }
        }
        return props ? `|${props}` : '';
    };
    const getAudiences = () => getTealiumProperties('va.audiences.', value => value);
    const getBadges = () => getTealiumProperties('va.badges.', (_, key) => key);
    return {
        getVisitorId,
        getAudiences,
        getBadges,
    };
}
export default Tealium(() => { var _a; return ((_a = window.utag) === null || _a === void 0 ? void 0 : _a.data) || {}; });
